import af from './af.json';
import ar from './ar.json';
import az from './az.json';
import bg_BG from './bg_BG.json';
import bn from './bn.json';
import ca from './ca.json';
import cs_CZ from './cs_CZ.json';
import da from './da.json';
import de from './de.json';
import dv from './dv.json';
import el_GR from './el_GR.json';
import en from './en.json';
import eo from './eo.json';
import es from './es.json';
import es_419 from './es_419.json';
import es_ES from './es_ES.json';
import es_MX from './es_MX.json';
import et from './et.json';
import eu from './eu.json';
import fa_IR from './fa_IR.json';
import fi from './fi.json';
import fr from './fr.json';
import gl from './gl.json';
import he from './he.json';
import hi_IN from './hi_IN.json';
import hr from './hr.json';
import hu_HU from './hu_HU.json';
import hy from './hy.json';
import id from './id.json';
import it_IT from './it_IT.json';
import ja from './ja.json';
import ka from './ka.json';
import km from './km.json';
import kn from './kn.json';
import ko_KR from './ko_KR.json';
import lt_LT from './lt_LT.json';
import lo_LA from './lo_LA.json';
import lv from './lv.json';
import ml from './ml.json';
import mn_MN from './mn_MN.json';
import nb_NO from './nb_NO.json';
import nl from './nl.json';
import oc from './oc.json';
import pt from './pt.json';
import pt_BR from './pt_BR.json';
import pl_PL from './pl_PL.json';
import ro_RO from './ro_RO.json';
import ru from './ru.json';
import sk_SK from './sk_SK.json';
import sl from './sl.json';
import sr from './sr.json';
import sv_SE from './sv_SE.json';
import ta from './ta.json';
import te from './te.json';
import th from './th.json';
import tr from './tr.json';
import tr_TR from './tr_TR.json';
import uk_UA from './uk_UA.json';
import vi from './vi.json';
import vi_VN from './vi_VN.json';
import zh_CN from './zh_CN.json';
import zh_TW from './zh_TW.json';

const messages = {
  af,
  ar,
  az,
  bg_BG,
  bg: bg_BG,
  bn,
  ca,
  cs_CZ,
  cs: cs_CZ,
  da,
  de,
  dv,
  el_GR,
  el: el_GR,
  en,
  eo,
  es,
  es_419,
  es_ES,
  es_MX,
  et,
  eu,
  fa_IR,
  fa: fa_IR,
  fi,
  fr,
  gl,
  he,
  hi_IN,
  hi: hi_IN,
  hr,
  hu_HU,
  hu: hu_HU,
  hy,
  id,
  it_IT,
  it: it_IT,
  ja,
  ka,
  km,
  kn,
  ko_KR,
  ko: ko_KR,
  lt_LT,
  lt: lt_LT,
  lo_LA,
  lo: lo_LA,
  lv,
  ml,
  mn_MN,
  mn: mn_MN,
  nb_NO,
  nb: nb_NO,
  nl,
  oc,
  pt,
  pt_BR,
  pl_PL,
  pl: pl_PL,
  ro_RO,
  ro: ro_RO,
  ru,
  sk_SK,
  sk: sk_SK,
  sl,
  sr,
  sv_SE,
  sv: sv_SE,
  ta,
  te,
  th,
  tr,
  tr_TR,
  uk_UA,
  uk: uk_UA,
  vi,
  vi_VN,
  zh: zh_CN,
  zh_CN,
  zh_TW,
};

export default messages;
